import React, { useState, useRef } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import Header from './Header';
import Sidebar from './Sidebar';
import ScrollRestoration from './ScrollRestoration';

const Layout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const scrollContainerRef = useRef(null);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Must close, not toggle: Sidebar calls this after every navigation, and on
  // desktop a toggle would open the hidden mobile drawer (its modal then sets
  // aria-hidden on #root while focus is still in the permanent sidebar).
  const handleDrawerClose = () => {
    setMobileOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <Sidebar open={mobileOpen} onClose={handleDrawerClose} />
      <ScrollRestoration scrollRef={scrollContainerRef} />

      <Box
        ref={scrollContainerRef}
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          height: '100vh',
          overflow: 'auto',
          backgroundColor: 'background.default',
        }}
      >
        <Header onMenuClick={handleDrawerToggle} />
        <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, py: { xs: 3, md: 4 }, maxWidth: 1280, mx: 'auto' }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
